import React from 'react';

const offerings = [
  {
    icon: '🗺️',
    title: 'Digital Transformation',
    desc: 'End-to-end roadmaps to modernize legacy systems and accelerate innovation across the organization.',
  },
  {
    icon: '📊',
    title: 'Technology Strategy',
    desc: 'Align your IT investments with business goals through data-driven planning and executive advisory.',
  },
  {
    icon: '🔄',
    title: 'Agile & Scrum Coaching',
    desc: 'Build high-performing teams with certified Scrum coaching and agile process implementation.',
  },
  {
    icon: '☁️',
    title: 'Cloud Migration',
    desc: 'Seamless migration to AWS, Azure, or Google Cloud with zero downtime and cost optimization.',
  },
  {
    icon: '🔐',
    title: 'Cybersecurity Consulting',
    desc: 'Risk assessments, compliance frameworks (SOC 2, ISO 27001), and security architecture reviews.',
  },
  {
    icon: '📈',
    title: 'ERP & CRM Optimization',
    desc: 'Maximize ROI on Salesforce, SAP, Dynamics 365, and other enterprise platforms.',
  },
];

const NorthAmericaConsulting = () => {
  return (
    <section id="north-america" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left content */}
          <div>
            <span className="inline-block bg-blue-100 text-primary text-sm font-semibold px-3 py-1 rounded-full mb-4">
              🌎 North America
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Strategic Consulting Across North America
            </h2>
            <p className="text-gray-500 text-lg mb-6 leading-relaxed">
              We serve enterprises and mid-market companies from Canada to Mexico, delivering technology consulting that drives measurable growth. Our bilingual consultants understand the unique regulatory and business landscape of North American markets.
            </p>
            <ul className="space-y-3 mb-8">
              {['US, Canada & Mexico market expertise', 'Bilingual (English/French) consulting teams', 'On-site and remote engagement models', 'Compliance with PIPEDA, CCPA, and SOX'].map((item, i) => (
                <li key={i} className="flex items-start gap-2 text-gray-600">
                  <span className="text-blue-500 mt-1">✔</span>
                  {item}
                </li>
              ))}
            </ul>
            <a
              href="#contact"
              className="inline-block bg-primary text-white px-7 py-3 rounded-full font-semibold hover:bg-blue-900 transition-colors"
            >
              Schedule a Discovery Call
            </a>
          </div>

          {/* Right grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {offerings.map((o, i) => (
              <div key={i} className="bg-gray-50 rounded-xl p-5 border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all">
                <div className="text-3xl mb-2">{o.icon}</div>
                <h4 className="font-bold text-gray-800 mb-1">{o.title}</h4>
                <p className="text-gray-500 text-sm leading-relaxed">{o.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NorthAmericaConsulting;
